/**
 * Utility functions for sharing shop information
 */

/**
 * Share shop information via Web Share API or fallback to copying to clipboard
 * @param {Object} shop - The shop object to share
 */
export const shareShop = (shop) => {
  const shareText = `Check out ${shop.name} in Bandar Sri Indah! 
Category: ${shop.category}
Description: ${shop.description}
Operating Hours: ${shop.hours || 'N/A'}
Phone: ${shop.phone || 'N/A'}`;

  const shareUrl = `https://www.google.com/maps?q=${shop.lat},${shop.lng}`;

  // Check if Web Share API is available
  if (navigator.share) {
    navigator.share({
      title: shop.name,
      text: shareText,
      url: shareUrl
    })
      .catch(error => console.log('Error sharing:', error));
  } else {
    // Fallback: copy to clipboard
    const textToCopy = `${shareText}\n\nLocation: ${shareUrl}`;
    navigator.clipboard.writeText(textToCopy)
      .then(() => {
        alert('Shop information copied to clipboard!');
      })
      .catch(err => {
        console.error('Failed to copy: ', err);
        // Fallback for older browsers
        const textArea = document.createElement('textarea');
        textArea.value = textToCopy;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        alert('Shop information copied to clipboard!');
      });
  }
};

/**
 * Get directions to a shop
 * @param {Object} shop - The shop object to get directions to
 */
export const getDirections = (shop) => {
  const url = `https://www.google.com/maps/dir/?api=1&destination=${shop.lat},${shop.lng}`;
  window.open(url, '_blank');
};

/**
 * Call a shop
 * @param {Object} shop - The shop object to call
 */
export const callShop = (shop) => {
  if (shop.phone) {
    window.open(`tel:${shop.phone}`, '_self');
  } else {
    alert('Phone number not available for this shop');
  }
};